import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import axios from 'axios'
import CoreuiVue from '@coreui/vue'
import {cilCart} from '@coreui/icons'
import VueRouter from 'vue-router'
import '@coreui/coreui/dist/css/coreui.min.css'
import App from './App.vue'
import MainPage from '@/routes/MainPage'
import CartPage from '@/routes/CartPage'
import ProductsPage from '@/routes/ProductsPage'
import SuccessPage from '@/routes/SuccessPage'

Vue.config.productionTip = false
Vue.use(CoreuiVue)
Vue.use(VueRouter)
Vue.use(Vuex)

const routes = [
    {path: '/', component: MainPage},
    {path: '/products', component: ProductsPage},
    {path: '/cart', component: CartPage},
    {path: '/success', component: SuccessPage}
]

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const store = new Vuex.Store({
    state: {
        _products: [],
        _picks: [],
        minFreeDelivery: 70,
        deliveryPrice: 15,
        nextDeliveryDate: null,
        name: '',
        paymentMethod: 'CA',
        municipality: '',
        houseNumber: '',
        flatNumber: '',
        postalCode: '',
        phone: '',
        email: '',
        street: '',
        notes: '',
        successOrderId: null,
        successDeliveryDate: null,
        successPaymentMethod: null,
        successBankAccount: null
    },
    getters: {
        products: (state) => state._products.map(prod => ({
            ...prod,
            pickCount: state._picks.filter(pick => pick.pk === prod.pk)[0].count
        })),
        totalPrice: (state, getters) => getters.products
            .filter(product => product.pickCount !== 0)
            .map(product => parseFloat(product.fields.unit_price) * parseFloat(product.pickCount))
            .reduce((a, b) => a + b, 0),
        deliveryPrice: (state, getters) => getters.totalPrice >= state.minFreeDelivery ? 0 : state.deliveryPrice,
        totalPricePlusDelivery: (state, getters) => getters.totalPrice + getters.deliveryPrice

    },
    mutations: {
        FETCH_PRODUCTS(state, products) {
            state._products = products
            state._picks = state._picks.filter(pick => state._products.map(prod => prod.pk).includes(pick.pk))
            for (const prod of state._products) {
                if (!(state._picks.map(pick => pick.pk).includes(prod.pk))) {
                    state._picks.push({pk: prod.pk, count: 0})
                }
            }
        },
        FETCH_DELIVERY_INFO(state, {
            deliveryPrice,
            minFreeDelivery,
            nextDeliveryDate
        }) {
            state.deliveryPrice = deliveryPrice
            state.minFreeDelivery = minFreeDelivery
            state.nextDeliveryDate = nextDeliveryDate
        },
        CLEAR_CART(state) {
            state._picks = state._products.map(prod => ({
                pk: prod.pk,
                count: 0
            }))
        },
        SET_PICK_COUNT(state, {productPk, count}) {
            state._picks = state._picks.map(pick => {
                if (pick.pk !== productPk)
                    return pick
                else return {
                    ...pick,
                    count: count
                }
            })
        },
        SET_NAME(state, name) {
            state.name = name
        },
        SET_PHONE(state, phone) {
            state.phone = phone
        },
        SET_EMAIL(state, email) {
            state.email = email
        },
        SET_STREET(state, street) {
            state.street = street
        },
        SET_HOUSE_NUMBER(state, houseNumber) {
            state.houseNumber = houseNumber
        },
        SET_FLAT_NUMBER(state, flatNumber) {
            state.flatNumber = flatNumber
        },
        SET_POSTAL_CODE(state, postalCode) {
            state.postalCode = postalCode
        },
        SET_MUNICIPALITY(state, municipality) {
            state.municipality = municipality
        },
        SET_PAYMENT_METHOD(state, paymentMethod) {
            state.paymentMethod = paymentMethod
        },
        SET_NOTES(state, notes) {
            state.notes = notes
        },
        SET_SUCCESS_DATA(state, {orderId, deliveryDate, paymentMethod, bankAccount}) {
            state.successOrderId = orderId
            state.successDeliveryDate = deliveryDate
            state.successPaymentMethod = paymentMethod
            state.successBankAccount = bankAccount
        },
        CLEAR_SUCCESS_DATA(state) {
            state.successOrderId = null
            state.successDeliveryDate = null
            state.successPaymentMethod = null
            state.successBankAccount = null
        }
    },
    actions: {
        fetchProducts({commit}) {
            axios
                .get((typeof webpackHotUpdate !== 'undefined' ? 'http://localhost:8081/admin/' : '/admin/') + 'products?limit=10000&json=1')
                .then(res => {
                    commit('FETCH_PRODUCTS', res.data.map(product => ({
                        ...product
                    })))
                })
                .catch(err => {
                    console.error(err.statusText)
                })
        },
        fetchDeliveryInfo({commit}) {
            axios
                .get((typeof webpackHotUpdate !== 'undefined' ? 'http://localhost:8081/admin/' : '/admin/') + 'api/delivery-info')
                .then(res => {
                    commit('FETCH_DELIVERY_INFO', {
                        minFreeDelivery: res.data.free_delivery_min_value,
                        deliveryPrice: res.data.delivery_price,
                        nextDeliveryDate: res.data.next_delivery_date
                    })
                })
                .catch(err => {
                    console.error(err.statusText)
                })
        },
        setPickCount({commit}, {productPk, count}) {
            commit('SET_PICK_COUNT', {productPk, count})
        }
    },
    plugins: [vuexLocal.plugin]
})

new Vue({
    render: h => h(App),
    router: new VueRouter({routes}),
    store: store,
    icons: {cilCart}
}).$mount('#app')
